<template>
  <div id="parent" class="container">
    <div class="product">
      <!-- <div class="bread-crumbs"></div> -->
      <div class="product-area" id="product-area" v-if="!isLoaded">
        <prod-selection-skeleton />
      </div>
      <div class="product-area" id="product-area" v-if="isLoaded">
        <product-selection :product="productDetails" />
      </div>
      <div v-if="pageName != 'used'">
        <div v-if="isLoaded" class="tabs" >
          <va-tabs v-model="activeTabName" grow >
            <template #tabs>
              <va-tab name="ProductDescriptionTab" class="tabs-individual">
                {{
                  $t("headerTitle.ProdDiscription")
                }}
              </va-tab>
              <va-tab name="ProductSpecificationsTab" class="tabs-individual">
                {{
                  $t("headerTitle.ProdSpecifications")
                }}
              </va-tab>
              <va-tab name="ProductCustomerReviewTab" class="tabs-individual">
                {{
                  $t("headerTitle.CusReviews")
                }}
              </va-tab>
              <va-tab name="ProductSellerTab" class="tabs-individual">
                {{
                  $t("headerTitle.AbtSeller")
                }}
              </va-tab>
            </template>
            <va-separator />
          </va-tabs>
          <component
            class="tab-section"
            :is="tabs[activeTabName]"
            :header="this.productDetails.prodName"
            :content="this.productDetails.content"
          />
        </div>
        
        <div class="trending-speciality-container" v-if="isLoaded">
          <product-similar />
        </div>
      </div>

      <!-- <div class="feature-section">
        <product-similar/>
        <div class="title-section">
          <span>Similar Products</span>
          <a href="#">View all</a>
        </div>
      </div> -->
    </div>
    <!-- <div v-if="!isLoaded" class="loading-height" ></div> -->
  </div>
</template>

<script>
import { defineAsyncComponent, markRaw } from "vue";
const ProductSelection = defineAsyncComponent(() =>
  import("@/views/Product/SubComponents/ProductSelection.vue")
);
const rawObject = markRaw({
  ProductDescriptionTab: defineAsyncComponent(() =>
    import("@/views/Product/Tabs/ProductDescriptionTab")
  ),
  ProductSpecificationsTab: defineAsyncComponent(() =>
    import("@/views/Product/Tabs/ProductSpecificationsTab")
  ),
  ProductCustomerReviewTab: defineAsyncComponent(() =>
    import("@/views/Product/Tabs/ProductCustomerReviewTab")
  ),
  ProductSellerTab: defineAsyncComponent(() =>
    import("@/views/Product/Tabs/ProductSellerTab")
  ),
});
const ProductSimilar = defineAsyncComponent(() =>
  import("@/views/Product/SubComponents/ProductSimilar.vue")
);
const ProdSelectionSkeleton = defineAsyncComponent(() =>
  import("@/components/ItemSkeletons/ProductSelectionSkeleton.vue")
);
import { getProductDetails } from "@/api/product";
import { getPreLovedProductDetails } from "@/api/preLoved";
import { getIdFromUrl } from "@/utils/slugify";


export default {
  name: "Product",
  data() {
    return {
      activeTabName: "ProductDescriptionTab",
      tabs: rawObject,
      productDetails: {},
      isLoaded: false,
      pageName: null,
    };
  },
  created() {
    // let urlParams = new URLSearchParams(window.location.search);
    // const productId = urlParams.get("a");
    // if (productId !== null) {
    //   this.getProdDetails(productId);
    // }
  },
  methods: {
    getProdDetails(productId) {
      if (productId !== "null") { {
          getProductDetails(productId).then((response) => {
            if (response.data && Object.keys(response.data).length > 0) {
              this.productDetails = response.data;
              this.isLoaded = true;
              this.$nextTick(() => {
                this.entireScrollToTop();
              });
            } else {
              // this.$router.push("/");
              this.isLoaded = true; 
            }
          })
          .catch((error) => {
            console.log(error);
          });
        }
      } else {
        console.log("Invalid productId");
      }
    },

    getPreLovedProdDetails(productId){
      try {
        getPreLovedProductDetails(productId).then((response) => {
        this.productDetails = response.data;
        this.isLoaded = true;
        this.$nextTick(() => {
          this.entireScrollToTop();
        });
      });
      } catch (error) {
        console.log(error);
        // this.$router.push("/");
      }
      
    },

    // scrollToTop(){
    //   const divEl = document.getElementById("product-area");
    //   divEl?.scrollIntoView()
    //   console.log('product-area scroll');
    // },
    entireScrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.entireScrollToTop();
  },
  components: {
    ProductSelection,
    ProductSimilar,
    ProdSelectionSkeleton,
    
  },
  watch: {
    "$route.params.productId": {
      immediate: true,
      handler(newUrl) {
        let urlParams = new URLSearchParams(window.location.search);
        const prodId = urlParams.get("a");
        const pageName = urlParams.get("Used");
        this.pageName = pageName;
        if(prodId !== null){
          if(pageName == "true"){
            this.getPreLovedProdDetails(prodId);
          }else{
            this.getProdDetails(prodId);
          }
        }else{
          const id = getIdFromUrl(newUrl);
          if(pageName == "true"){
            this.getPreLovedProdDetails(id);
          }else{
            this.getProdDetails(id);
          }
          // this.getProdDetails(id);
        }
        this.$nextTick(() => {
          this.entireScrollToTop();
        });
      },
    },
  },
};
</script>

<style scoped lang="sass">
@import "@/assets/layout/styles/__variables.sass"

.container
  min-height: 100vh
  display: flex
  flex-direction: row
  justify-content: center
  align-items: center
  padding: 1rem
  margin-top: 1rem
  @media screen and (max-width: $md)
    margin-top: 0rem
.product
  align-self: flex-start
  display: flex
  flex-direction: column
  width: 86vw
  max-width: 1500px
  // max-width: $section-max-width
  @media screen and (max-width: $md)
    margin-top: 0rem
    width: 95vw
  @media screen and (max-width: $sm)
    width: 98vw
    margin-top: 0rem
  .tabs
    //display: block
    width: 100%
    padding-top: 5px
    .tabs-individual
      @media (max-width: 450px)
        width: 73vw
    .tab-section
      margin-top: 1rem

.product-description-container
  display: flex
  @media (max-width: 450px)
    flex-direction: column
    align-items: center

.image-container
  margin-right: 1rem
  width: 35%
  @media (max-width: 450px)
    width: 60%
    margin-bottom: 1rem

.description-container
  width: 65%
  @media (max-width: 450px)
    width: 100%

.trending-speciality-container
  display: flex
  justify-content: center
  align-items: center
  margin-top: 1.5rem
  @media (max-width: 835px)
    display: block

.loading-height
  min-height: 85vh

@media (max-width: 768px) 
  .tabs 
    display: none

  .tab-section
    display: none
</style>
